<template>
  <div id="food-diary">
    <mu-paper class="foodbar">
      <mu-content-block class="foodBar inner">
        <mu-row gutter>
          <mu-col desktop="30" width="25" tablet="30" align="right">
            <mu-flexbox>
              <mu-flexbox-item align="right">
                <mu-icon-button
                  @click.native="subtractDay()"
                  icon="chevron_left"
                ></mu-icon-button>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-col>
          <mu-col width="50" style="flex: auto" align="center">
            <mu-flexbox align="center center" justify="center center" style="height: 46px;">
              <mu-flexbox-item ref="datepicker" class="c-datepicker-btn mediumTitle" align="center" grow>
                <mu-flexbox justify="center center" align="center" wrap="disallow" style="position:relative;">
                  <mu-flexbox-item align="center" style="cursor: pointer">
                    <mu-date-picker
                      class="hiddenPicker"
                      inputClass="datePicker"
                      :okLabel="$t('message.okText')"
                      :cancelLabel="$t('message.cancelText')"
                      :dateTimeFormat="dateFormat"
                      format="DD-MM-YYYY"
                      v-model="currentDate.ddmmyy"
                      fullWidth></mu-date-picker>
                    <span>
                       <mu-icon style="position:relative;top:4px;" value="date_range"></mu-icon>
                      {{currentDate.presentational}}
                    </span>
                  </mu-flexbox-item>
                </mu-flexbox>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-col>
          <mu-col desktop="30" width="25" tablet="30" align="left">
            <mu-flexbox>
              <mu-flexbox-item>
                <mu-icon-button
                  @click.native="addDay()"
                  icon="chevron_right"
                ></mu-icon-button>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-col>
        </mu-row>
      </mu-content-block>
    </mu-paper>
    <mu-paper style="display: none;" id="controls" class="foodbar">
      <mu-content-block>
        <mu-flexbox>
          <mu-flexbox-item>
            <mu-raised-button fullWidth label="Add food"></mu-raised-button>
          </mu-flexbox-item>
          <mu-flexbox-item align="left" v-if="!isToday(currentDate.actual)">
            <mu-raised-button
              fullWidth
              @click.native="setToday()"
              secondary :label="$t('message.labelToday')"></mu-raised-button>
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-content-block>
    </mu-paper>

    <!-- Intake bar -->
    <mu-paper class="intakebar desktop bottom">
      <mu-content-block class="content">
        <mu-row>
          <mu-col width="100" desktop="50" tablet="50">
            <div class="mediumTitle progress-item"
                 v-text="isToday(currentDate.actual) ? $t('message.foodDiaryIntakeBar'): $t('message.foodDiaryIntakeBarNotToday')">
              {{$t('message.foodDiaryTodayYouveHad')}}
            </div>
            <ProgressItem
              :bar-mode="barMode"
              color="#4ed8da"
              :total="getNutrientDisplayValue( nutritionTargets.carbohydrate, 'carbohydrate')"
              :unit="this.nutritionUnit"
              :value="getNutrientDisplayValue(totals.all.carbohydrate, 'carbohydrate')"
              label="carbs"
            />
            <ProgressItem
              :bar-mode="barMode"
              color="#c04dd8"
              :total="getNutrientDisplayValue( nutritionTargets.fat, 'fat')"
              :unit="this.nutritionUnit"
              :value="getNutrientDisplayValue(totals.all.fat, 'fat')"
              label="fat"
            />
            <ProgressItem
              :bar-mode="barMode"
              color="#e06950"
              :total="getNutrientDisplayValue( nutritionTargets.protein, 'protein')"
              :unit="this.nutritionUnit"
              :value="getNutrientDisplayValue(totals.all.protein, 'protein')"
              :last="true"
              label="protein"
            />
            <br/>
            <div align="right">
              <mu-flat-button
                v-bind:id="'editNutritionUnit'"
                @click.native="openDialog('editNutritionUnitDialog')"
                labelClass="grey"
                iconClass="grey"
                label="Configure Charts"
                icon="settings"
                primary
              />
              <mu-flat-button
                v-bind:id="'setTargets'"
                @click.native="openDialog('setTargetsDialog')"
                labelClass="grey"
                iconClass="grey"
                :label="$t('message.foodDiaryModifyTargets')"
                icon="edit"
                primary
              />
            </div>
          </mu-col>
          <mu-col width="100" desktop="50" tablet="50" style="margin-top: -8px;" class="holdDoughnut" align="center">
            <div style="height: 201px" class="innerDoughnut">
              <mu-flexbox style="height: 100%; margin-top: 16px;" v-if="barMode === 'indeterminate'">
                <mu-flexbox-item align="center">
                  <mu-circular-progress :size="156"></mu-circular-progress>
                </mu-flexbox-item>
              </mu-flexbox>
              <mu-row align="center" style="width: 100%; margin-top: 16px;" v-if="barMode === 'indeterminate'">
                <mu-col align="center" width="100" desktop="100" tablet="100">
                  {{$t('message.loadingText')}}
                </mu-col>
              </mu-row>
              <food-pie-empty
                class="foodPie"
                v-if="barMode !== 'indeterminate' && totals.all.calories === 0"
              ></food-pie-empty>
              <food-pie
                class="foodPie"
                v-if="barMode !== 'indeterminate' && totals.all.calories > 0"
                :fat="getNutrientDisplayValue(totals.all.fat, 'fat')"
                :carbs="getNutrientDisplayValue(totals.all.carbohydrate, 'carbohydrate')"
                :protein="getNutrientDisplayValue(totals.all.protein, 'protein')"
                :calories="totals.all.calories"
              ></food-pie>
              <mu-row align="center" style="width: 100%; margin-top: 16px;" v-if="barMode !== 'indeterminate'">
                <mu-col width="33" desktop="33" tablet="33">
                <span class="mediumTitle">
                  <mu-badge color="#4ed8da !important" badgeClass="smallBadge" content="" circle></mu-badge>
                  <span>{{getNutrientDisplayValue(totals.all.carbohydrate, 'carbohydrate', true)}}</span>
                </span>
                  <br/>
                  <label class="grey" v-text="$t('message.nutrientCarbohydrateShort')"></label>
                </mu-col>
                <mu-col width="33" desktop="33" tablet="33">
                <span class="mediumTitle">
                  <mu-badge color="#c04dd8 !important" badgeClass="smallBadge" content="" circle></mu-badge>
                 <span>{{getNutrientDisplayValue(totals.all.fat, 'fat', true)}}</span>
                </span>
                  <br/>
                  <label class="grey" v-text="$t('message.nutrientFat')">Fat</label>
                </mu-col>
                <mu-col width="33" desktop="33" tablet="33">
                <span class="mediumTitle">
                  <mu-badge color="#e06950 !important" badgeClass="smallBadge" content="" circle></mu-badge>
                    <span>{{getNutrientDisplayValue(totals.all.protein, 'protein', true)}}</span>
                </span>
                  <br/>
                  <label class="grey" v-text="$t('message.nutrientProtein')"></label>
                </mu-col>
              </mu-row>
            </div>
          </mu-col>
        </mu-row>
      </mu-content-block>
    </mu-paper>

    <!-- Intake bar mobile -->
    <mu-paper class="intakebar mobile bottom" style="padding: 24px;">
      <mu-content-block>
        <md-boards :md-auto="false" :md-swipeable="true">
          <md-board>
            <div>
              <mu-flexbox style="height: 100%; margin-top: 16px;" v-if="barMode === 'indeterminate'">
                <mu-flexbox-item style="height: 148px;" align="center">
                  <mu-circular-progress :size="74"></mu-circular-progress>
                  <br/>
                  {{$t('message.loadingText')}}
                </mu-flexbox-item>
              </mu-flexbox>
              <div style="height: 148px;" v-if="barMode !== 'indeterminate'">
                <food-pie-empty
                  style="height: 148px;"
                  v-if="totals.all.calories === 0"
                ></food-pie-empty>
                <food-pie
                  v-if="totals.all.calories > 0"
                  style="height: 148px;"
                  :fat="getNutrientDisplayValue(totals.all.fat, 'fat')"
                  :carbs="getNutrientDisplayValue(totals.all.carbohydrate, 'carbohydrate')"
                  :protein="getNutrientDisplayValue(totals.all.protein, 'protein')"
                  :calories="totals.all.calories"
                ></food-pie>
              </div>
              <mu-row align="center" style="width: 100%; margin-top: 16px;" v-if="barMode !== 'indeterminate'">
                <mu-col width="33" desktop="33" tablet="33">
                <span class="mediumTitle">
                  <mu-badge color="#4ed8da !important" badgeClass="smallBadge" content="" circle></mu-badge>
                   <span>{{getNutrientDisplayValue(totals.all.carbohydrate, 'carbohydrate', true)}}</span>
                </span>
                  <br/>
                  <label class="grey" v-text="$t('message.nutrientCarbohydrateShort')"></label>
                </mu-col>
                <mu-col width="33" desktop="33" tablet="33">
                <span class="mediumTitle">
                  <mu-badge color="#c04dd8 !important" badgeClass="smallBadge" content="" circle></mu-badge>
                   <span>{{getNutrientDisplayValue(totals.all.fat, 'fat', true)}}</span>
                </span>
                  <br/>
                  <label class="grey" v-text="$t('message.nutrientFat')">Fat</label>
                </mu-col>
                <mu-col width="33" desktop="33" tablet="33">
                <span class="mediumTitle">
                  <mu-badge color="#e06950 !important" badgeClass="smallBadge" content="" circle></mu-badge>
                  <span>{{getNutrientDisplayValue(totals.all.protein, 'protein', true)}}</span>
                </span>
                  <br/>
                  <label class="grey" v-text="$t('message.nutrientProtein')"></label>
                </mu-col>
              </mu-row>
            </div>
          </md-board>
          <md-board>
            <div class="mediumTitle progress-item"
                 v-text="isToday(currentDate.actual) ? $t('message.foodDiaryIntakeBar'): $t('message.foodDiaryIntakeBarNotToday')">

            </div>
            <div class="progress-item">
              <label><span
                v-text="$t('message.nutrientCarbohydrateShort')"></span>:
                {{getNutrientDisplayValue(totals.all.carbohydrate, 'carbohydrate', true)}}</label>
              <mu-linear-progress
                :color="barMode === 'indeterminate' ? 'rgba(78, 216, 218, 0.24)': '#4ed8da'"
                :size="16"
                :mode="barMode"
                :value="(totals.all.carbohydrate) ? (totals.all.carbohydrate / nutritionTargets.carbohydrate * 100) : 0"
              ></mu-linear-progress>
            </div>
            <div class="progress-item">
              <label><span
                v-text="$t('message.nutrientFat')"></span>:
                {{getNutrientDisplayValue(totals.all.fat, 'fat', true)}}</label>
              <mu-linear-progress
                :color="barMode === 'indeterminate' ? 'rgba(192, 77, 216, 0.24)': '#c04dd8'"
                :size="16"
                :mode="barMode"
                :value="(totals.all.fat) ? (totals.all.fat / nutritionTargets.fat * 100) : 0"
              ></mu-linear-progress>
            </div>
            <div class="progress-item last">
              <label><span
                v-text="$t('message.nutrientProtein')"></span>:
                {{getNutrientDisplayValue(totals.all.protein, 'protein', true)}}</label>
              <mu-linear-progress
                :color="barMode === 'indeterminate' ? 'rgba(224, 105, 80, 0.24)': '#e06950'"
                :size="16"
                :mode="barMode"
                :value="(totals.all.protein) ? (totals.all.protein / nutritionTargets.protein * 100) : 0"
              ></mu-linear-progress>
            </div>
            <br/>
            <div align="right">
              <mu-flat-button
                v-bind:id="'editNutritionUnit'"
                @click.native="openDialog('editNutritionUnitDialog')"
                labelClass="grey"
                iconClass="grey"
                label="Configure Charts"
                icon="settings"
                primary
              />
              <mu-flat-button
                v-bind:id="'setTargets'"
                @click.native="openDialog('setTargetsDialog')"
                labelClass="grey"
                iconClass="grey"
                :label="$t('message.foodDiaryModifyTargets')"
                icon="edit"
                primary
              />
            </div>
          </md-board>
        </md-boards>
      </mu-content-block>
    </mu-paper>

    <div class="content bottom">
      <mu-row gutter>
        <mu-col width="50" tablet="50" desktop="50">
          <mu-raised-button
            style="height: 54px;color:#0179d5"
            @click.native="goTo('FoodDiaryHistory')"
            icon="equalizer"
            :label="$t('message.labelViewHistory')"
            fullWidth
          ></mu-raised-button>
        </mu-col>
        <mu-col width="50" tablet="50" desktop="50">
          <mu-raised-button
            style="height: 54px;color:#0179d5"
            @click.native="openDialog('exportDataDialog')"
            icon="file_download"
            :label="$t('message.exportTextData')"
            fullWidth
          ></mu-raised-button>
        </mu-col>
      </mu-row>
    </div>

    <!-- Set targets -->
    <md-dialog ref="setTargetsDialog">
      <mu-card-header
        :title="$t('message.foodDiaryNutritionPanelHeaderText')"
        :subTitle="$t('message.foodDiaryNutritionPanelSubHeaderText')"
        titleClass="blueTitle largeTitle"
      ></mu-card-header>
      <mu-card-text style="overflow-x: hidden;overflow-y: scroll;-webkit-overflow-scrolling: touch;">

        <mu-select-field :label="$t('message.labelNutrientTargetHelpText')" v-model="preset" fullWidth>
          <mu-menu-item v-for="item, index in nutrientPresets" :key="'preset-' + index" :title="item.name"
                        :value="item"></mu-menu-item>
        </mu-select-field>

        <form>
          <div><span v-text="$t('message.nutrientCarbohydrateShort')"></span> <span style="color: #0179d5;"
                                                                                    v-text="settingsModel.carbohydrate + 'g'"></span>
            <span style="float:right;" v-text="300 + 'g'"></span>

          </div>
          <div align="right">
            <mu-slider
              class="carbohydrate-slider"
              :step="1"
              v-model.number="settingsModel.carbohydrate"
              :max="300"
            ></mu-slider>
          </div>
          <div>
            <span v-text="$t('message.nutrientFat')"></span> <span style="color: #ff895e;"
                                                                   v-text="settingsModel.fat + 'g'"></span>
            <span style="float:right" v-text="350 + 'g'"></span>
          </div>
          <div align="right">
            <mu-slider
              class="fat-slider"
              :step="1"
              v-model.number="settingsModel.fat"
              :max="350"
            ></mu-slider>
          </div>
          <div>
            <span v-text="$t('message.nutrientProtein')"></span> <span style="color: #ff5a5f;"
                                                                       v-text="settingsModel.protein + 'g'"></span>
            <div style="float:right" v-text="350 + 'g'"></div>
          </div>
          <div align="right">
            <mu-slider
              class="protein-slider"
              :step="1"
              v-model.number="settingsModel.protein"
              :max="350"
            ></mu-slider>

          </div>
        </form>
      </mu-card-text>
      <mu-card-actions align="right">
        <mu-flat-button
          :label="$t('message.cancelText')"
          @click.native="closeDialog('setTargetsDialog')"
        ></mu-flat-button>
        <mu-flat-button
          @click.native="updateTargets"
          :label="isSettingsUpdating ? $t('message.updatingText') : $t('message.updateText')"
          primary
        ></mu-flat-button>
      </mu-card-actions>
    </md-dialog>


    <md-dialog ref="exportDataDialog">
      <mu-card-header :title="$t('message.foodDiaryExportDataTitle')"
                      :subTitle="$t('message.foodDiaryExportDataSubTitle')"></mu-card-header>

      <mu-card-text>

        <mu-row gutter>
          <mu-col width="100" desktop="50" tablet="50">
            <mu-date-picker
              :label="$t('message.labelFromDate')"
              v-model="exportDate.fromDate"
              :dateTimeFormat="dateFormat"
              :okLabel="$t('message.okText')"
              :cancelLabel="$t('message.cancelText')"
              format="DD-MM-YYYY"
              fullWidth
            >
            </mu-date-picker>
          </mu-col>
          <mu-col width="100" desktop="50" tablet="50">
            <mu-date-picker
              :label="$t('message.labelToDate')"
              v-model="exportDate.toDate"
              :dateTimeFormat="dateFormat"
              :okLabel="$t('message.okText')"
              :cancelLabel="$t('message.cancelText')"
              format="DD-MM-YYYY"
              fullWidth
            >
            </mu-date-picker>
          </mu-col>
        </mu-row>

      </mu-card-text>
      <mu-card-actions align="right">
        <mu-flat-button @click.native="closeDialog('exportDataDialog')"
                        :label="$t('message.discardText')"></mu-flat-button>
        <mu-flat-button @click.native="exportData" :disabled="isExporting"
                        :label="isExporting ? $t('message.exportingText'): $t('message.exportText')"></mu-flat-button>
      </mu-card-actions>
    </md-dialog>

    <!-- Add food dialog -->
    <md-dialog class="food-dialog-container" ref="addFoodDialog" @close="onFoodDialogClose" @open="onFoodDialogOpen">
      <div class="add-food-dialog" v-bind:class="{extraHeight: activeDialogMethod === 'searchResult'}">


        <!-- Choose method of adding food/landing panel-->
        <fd-landing-dialog
          v-if="activeDialogMethod === null"
          :title="activeMealType.panelTitle"
          :mealTypeId="activeMealType.mealTypeId"
          :date="currentDate.actual.format()"
          @choseToSearchWith="searchMethod"
          @closeDialogAndReload="closeDialogAndReload('addFoodDialog')"
          @closeDialog="closeDialog('addFoodDialog')"
          @onRecentItemSelected="selectRecent"
        ></fd-landing-dialog>

        <!-- Search dialog -->
        <fd-autocomplete-dialog
          v-if="activeDialogMethod === 'autocomplete'"
          :searchTerm="selectedSearchTerm"
          :title="activeMealType.panelTitle"
          @closeDialog="closeDialog('addFoodDialog')"
          @foodNameSelected="foodNameSelected"
        ></fd-autocomplete-dialog>

        <!-- Search dialog -->
        <fd-mymeals-dialog
          v-if="activeDialogMethod === 'mymeals'"
          :mealTypeId="activeMealType.mealTypeId"
          :date="currentDate.actual.format()"
          :title="activeMealType.panelTitle"
          @closeDialog="closeDialog('addFoodDialog')"
          @closeDialogAndReload="closeDialogAndReload('addFoodDialog')"
          @foodNameSelected="foodNameSelected"
        ></fd-mymeals-dialog>

        <!-- Food search results panel -->
        <fd-search-results-dialog
          v-if="activeDialogMethod === 'searchResults'"
          :title="activeMealType.panelTitle"
          :searchTerm="selectedSearchTerm"
          @goBack="searchMethod"
          @foodSelected="foodSelected"
          @closeDialog="closeDialog('addFoodDialog')"
        ></fd-search-results-dialog>

        <!-- Food result panel -->
        <fd-food-result-dialog
          v-if="activeDialogMethod === 'searchResult' || activeDialogMethod === 'editResult'"
          :inputDate="currentDate.ddmmyy"
          :title="activeMealType.panelTitle"
          :mealTypeId="activeMealType.mealTypeId"
          :foodId="foodResultId"
          :mode="foodResultMode"
          @foodAdded="getData()"
          @goBack="searchMethod"
          @closeDialog="closeDialog('addFoodDialog')"
        ></fd-food-result-dialog>

      </div>
    </md-dialog>


    <md-dialog class="food-dialog-container" ref="editFoodDialog" @close="onEditDialogClose">
      <mu-card class="add-food-dialog" v-bind:class="{extraHeight: selectedFood.fs_food_id}">
        <fd-edit-food-dialog
          v-if="selectedFood.fs_food_id"
          :mealTypeId="1"
          :foodObj="selectedFood"
          @closeDialog="closeDialog('editFoodDialog')"
          @foodUpdated="getData()"
        ></fd-edit-food-dialog>
      </mu-card>
    </md-dialog>


    <div class="content">
      <!--Breakfast list -->
      <fd-meal-list
        class="bottom"
        :totals="totals.breakfast"
        :foods="foods.breakfast"
        :recipes="recipes.breakfast"
        :mealTypeTitle="$t('message.foodDiaryBreakfast')"
        mealType="breakfast"
        :isLoading="isLoading"
        @foodSelected="openEditPane"
        @removeFood="removeBreakfast"
        @removeRecipe="removeRecipe"
        @updateTotals="updateTotals"
        @reloadData="getData"
      >
        <mu-icon-button
          labelPosition="before"
          slot="button"
          icon="add_circle"
          v-tooltip.top="$t('message.addEntryText')"
          @click.native="openDialog('addFoodDialog', {
          panelTitle: $t('message.foodDiaryAddingBreakfast'),
          mealType: 'breakfast',
          mealTypeId: 1
        })"
        >
        </mu-icon-button>
      </fd-meal-list>

      <!-- Lunch list -->
      <fd-meal-list
        class="bottom"
        :totals="totals.lunch"
        :foods="foods.lunch"
        :recipes="recipes.lunch"
        :mealTypeTitle="$t('message.foodDiaryLunch')"
        mealType="lunch"
        :isLoading="isLoading"
        @foodSelected="openEditPane"
        @removeFood="removeLunch"
        @removeRecipe="removeRecipe"
        @updateTotals="updateTotals"
        @reloadData="getData"
      >
        <mu-icon-button
          labelPosition="before"
          slot="button"
          icon="add_circle"
          v-tooltip.top="$t('message.addEntryText')"
          @click.native="openDialog('addFoodDialog', {
          panelTitle: $t('message.foodDiaryAddingLunch'),
          mealType: 'lunch',
          mealTypeId: 2
        })"
        ></mu-icon-button>
      </fd-meal-list>

      <!-- Dinner list -->
      <fd-meal-list
        class="bottom"
        :totals="totals.dinner"
        :foods="foods.dinner"
        :recipes="recipes.dinner"
        :mealTypeTitle="$t('message.foodDiaryDinner')"
        mealType="dinner"
        :isLoading="isLoading"
        @foodSelected="openEditPane"
        @removeFood="removeDinner"
        @removeRecipe="removeRecipe"
        @updateTotals="updateTotals"
        @reloadData="getData"
      >
        <mu-icon-button
          labelPosition="before"
          slot="button"
          icon="add_circle"
          v-tooltip.top="$t('message.addEntryText')"
          @click.native="openDialog('addFoodDialog', {
          panelTitle: $t('message.foodDiaryAddingDinner'),
          mealType: 'dinner',
          mealTypeId: 3
        })"
        >
        </mu-icon-button>
      </fd-meal-list>

      <!-- Snack list -->
      <fd-meal-list
        class="bottom"
        :totals="totals.snack"
        :foods="foods.snack"
        :recipes="recipes.snack"
        :mealTypeTitle="$t('message.foodDiarySnack')"
        mealType="snack"
        :isLoading="isLoading"
        @foodSelected="openEditPane"
        @removeFood="removeSnack"
        @removeRecipe="removeRecipe"
        @updateTotals="updateTotals"
        @reloadData="getData"
      >
        <mu-icon-button
          labelPosition="before"
          slot="button"
          icon="add_circle"
          v-tooltip.top="$t('message.addEntryText')"
          @click.native="openDialog('addFoodDialog', {
          panelTitle: $t('message.foodDiaryAddingSnack'),
          mealType: 'snack',
          mealTypeId: 4
        })"
        ></mu-icon-button>
      </fd-meal-list>
      <!--nutrition unit display select dialog-->

        <NutritionUnitDialog ref="editNutritionUnitDialog" v-on:nutritionUnitChanged="onNutritionUnitUpdate" v-on:close="closeDialog('editNutritionUnitDialog')" :initialUnit="nutritionUnit"/>

    </div>
  </div>
</template>
<script>


  import ProgressItem from "../../components/FoodDiary/Graphs/ProgressItem/ProgressItem";
  let barMode = "indeterminate", defaults = {fat: 0, protein: 0, carbohydrate: 0};

  import './food-diary.css';

  import FoodApi from '../../api/Food';
  import SettingsApi from '../../api/Settings';
  import config from '../../config';
  import download from 'downloadjs'
  import axios from 'axios'


  import dateFormat from "../../helpers/DatePickerManager"
  import FdMealList from "../../components/FoodDiary/MealList/MealList";
  import FdLandingDialog from "../../components/FoodDiary/LandingDialog/LandingDialog";
  import FdAutocompleteDialog from "../../components/FoodDiary/AutocompleteDialog/AutocompleteDialog";
  import FdSearchResultsDialog from "../../components/FoodDiary/SearchResultsDialog/SearchResultsDialog.vue";
  import FdFoodResultDialog from "../../components/FoodDiary/FoodResultDialog/FoodResultDialog";
  import FdEditFoodDialog from "../../components/FoodDiary/FoodEditDialog/FoodEditDialog";
  import FoodDiaryNutritionMixin from "../../mixins/FoodDiaryNutritionMixin"
  import DatePicker from "../../components/DateTimePicker/DateTimePicker";
  import FdMymealsDialog from "../../components/FoodDiary/MyMeals/MyMeals";
  import NutritionUnitDialog from "../../components/FoodDiary/NutritionUnitDialog/NutritionUnitDialog";


  const nutrientPresets = [
    {
      name: 'Low Carb',
      locale: 'message.dietPlanLowCarb',
      fat: 100,
      protein: 100,
      carbohydrate: 120
    },
    {
      name: 'Keto',
      locale: 'message.dietPlanKeto',
      fat: 150,
      protein: 120,
      carbohydrate: 50
    },
    {
      name: 'Custom',
      locale: 'message.labelCustom',
      fat: 100,
      protein: 100,
      carbohydrate: 120
    }
  ];


  let foods = {
    breakfast: [],
    lunch: [],
    dinner: [],
    snack: []
  };

  export default {
    mixins: [FoodDiaryNutritionMixin],
    components: {
      NutritionUnitDialog,
      ProgressItem,
      FdMymealsDialog,
      DatePicker,
      FdEditFoodDialog,
      FdFoodResultDialog,
      FdAutocompleteDialog,
      FdLandingDialog,
      FdMealList,
      FdSearchResultsDialog
    },
    name: 'food-diary',
    data() {
      return {
        nutrientPresets: nutrientPresets,
        isExporting: false,
        preset: {
          name: 'Low Carb',
          fat: 100,
          protein: 100,
          carbohydrate: 120
        },
        exportDate: {
          fromDate: moment().subtract(7, 'days').format('DD-MM-YYYY'),
          toDate: moment().format('DD-MM-YYYY')
        },
        window: $(window),
        dateFormat: dateFormat,
        // True only during mount. The DST / ?date= adjustments below reassign
        // currentDate.ddmmyy, which would trigger the ddmmyy watcher and reload
        // the diary — on top of the explicit getData() in mounted(). The guard
        // lets the single explicit load own initialisation; date navigation
        // (arrows / picker) still reloads normally once this is false.
        isInitialising: true,
        isLoading: true,
        picker: "",
        foodResultId: 0,
        selectedFood: {},
        selectedSearchTerm: "",
        foodResultMode: "",
        activeDialogMethod: null,
        foods: foods,
        recipes: {
          all: [],
          breakfast: [],
          lunch: [],
          dinner: [],
          snack: []
        },
        config: {
          wrap: true,
          dateFormat: "d-m-y",
        },
        activeMealType: {},
        barMode: barMode,
        nutritionTargets: defaults,
        settingsModel: defaults,
        isSettingsUpdating: false,
        totals: {
          all: defaults,
          breakfast: defaults,
          dinner: defaults,
          snack: defaults
        },
        currentDate: {
          ddmmyy: moment().utc().local().format('DD-MM-YYYY HH:mm a'),
          actual: moment.utc().local(),
          presentational: config.dateFormatting.foodDiaryDate(moment().utc().local())
        },
        nutritionUnit: 'g',
      }
    },
    async mounted() {
      let self = this;
      self.$gtag.pageview('/food-diary');
      self.window = $(window);
      if (self.isDst(self.currentDate.actual)) {
        self.currentDate.actual = moment.utc().add(1, 'hour').toDate();
        self.currentDate.ddmmyy = moment.utc().add(1, 'hour').format('DD-MM-YYYY');
        self.currentDate.presentational = config.dateFormatting.foodDiaryDate(moment().utc().add(1, 'hour'))
      }

      if (self.$route.query.date) {
        self.currentDate.actual = moment(self.$route.query.date, 'YYYY-MM-DD');
        self.currentDate.ddmmyy = moment(self.$route.query.date, 'YYYY-MM-DD').format('DD-MM-YYYY');
        self.currentDate.presentational = config.dateFormatting.foodDiaryDate(self.currentDate.actual);
        self.$forceUpdate();
      }

      await self.$nextTick(async function () {
        try {
          const responses = await Promise.all([SettingsApi.getNutritionSettings(), SettingsApi.getFoodDiaryNutritionUnit()]);
          const nutritionTargets = responses[0].data;
          self.nutritionTargets = nutritionTargets
          self.settingsModel = JSON.parse(JSON.stringify(nutritionTargets));

          if (self.settingsModel.carbohydrate === 120 && self.settingsModel.protein === 100 && self.settingsModel.fat === 100) {
            self.preset = self.nutrientPresets[0];
          }
          if (self.settingsModel.carbohydrate === 50 && self.settingsModel.protein === 120 && self.settingsModel.fat === 150) {
            self.preset = self.nutrientPresets[1];
          }
          else if (self.settingsModel.carbohydrate === 0 && self.settingsModel.protein === 0 && self.settingsModel.fat === 0) {
            self.preset = self.nutrientPresets[0];
          }
          else {
            self.preset = self.nutrientPresets[2];
            self.preset.carbohydrate = nutritionTargets.carbohydrate;
            self.preset.fat = nutritionTargets.fat;
            self.preset.protein = nutritionTargets.protein;
          }
          const {unit} = responses[1].data;
          if (unit && unit.length) {
            self.nutritionUnit = unit;
          }
          self.getData();
        } catch (error) {

        } finally {
          // Mount-time date adjustments are done; let date navigation reload again.
          self.isInitialising = false;
        }
      })
    },
    watch: {
      '$route.query.date': function () {
        let self = this;
        if (self.$route.query.date) {
          self.currentDate.actual = moment(self.$route.query.date);
          self.currentDate.presentational = config.dateFormatting.foodDiaryDate(self.$route.query.date);
          self.$forceUpdate();
          self.getData();
        }

      },
      'preset': function () {
        this.settingsModel.carbohydrate = this.preset.carbohydrate;
        this.settingsModel.fat = this.preset.fat;
        this.settingsModel.protein = this.preset.protein;
      },
      "currentDate.ddmmyy": function () {
        let self = this;
        self.currentDate.presentational = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY').format('dddd Do MMMM, YYYY');
        self.currentDate.actual = moment(self.currentDate.ddmmyy, 'DD-MM-YYYY');
        self.$forceUpdate();
        // Skip during mount — mounted() does the initial load itself, otherwise
        // the DST/?date= adjustments would cause a second, duplicate fetch.
        if (!self.isInitialising) {
          self.getData();
        }
      },
    },
    methods: {
      isDst(date) {
        return moment(date).isDST();
      },
      closeDialogAndReload: function closeDialogAndReload(ref) {
        let self = this;
        self.currentDate.actual = moment(self.currentDate.actual);
        self.getData();
        $('.scrollable-area').attr('style', '');
        self.$refs[ref].close();
        setTimeout(function () {
          self.activeDialogMethod = null;
          self.foodResultMode = "";
        }.bind(self), 300);
      },
      selectRecent: function selectRecent(foodId) {
        let self = this;
        self.activeDialogMethod = "searchResult";
        self.foodResultMode = "noBack";
        self.foodResultId = foodId;
      },
      removeRecipe: function removeRecipe(event) {
        let self = this;
        Number.prototype.clamp = function (min, max) {
          return Math.min(Math.max(this, min), max);
        };
        let recipe = self.recipes[event.type][event.index];
        let currentItem = self.recipes.all.filter(function (item) {
          return item.id === recipe.id;
        });
        let allIndex = self.recipes.all.indexOf(currentItem[0]);
        self.recipes.all.splice(allIndex, 1);
        self.recipes[event.type].splice(event.index, 1);
        self.getData();
        self.$forceUpdate();
      },
      removeBreakfast: function removeBreakfast(index) {
        let self = this;
        self.foods.breakfast.splice(index, 1);
        self.getData();
      },
      removeLunch: function removeLunch(index) {
        let self = this;
        self.foods.lunch.splice(index, 1);
        self.getData();
      },
      removeDinner: function removeDinner(index) {
        let self = this;
        self.foods.dinner.splice(index, 1);
        self.getData();
      },
      removeSnack: function removeSnack(index) {
        let self = this;
        self.foods.snack.splice(index, 1);
        self.getData();
      },
      openEditPane: function openEditPane(food) {
        let self = this;
        self.openDialog('editFoodDialog', food);
      },
      foodSelected: function foodSelected(food) {
        let self = this;
        self.activeDialogMethod = "searchResult";
        self.foodResultId = parseInt(food.food_id);
        self.$forceUpdate();
      },
      /**
       * Sets food search term
       * @param method
       * @param foodName
       */
      foodNameSelected: function foodNameSelected(method, foodName) {
        let self = this;
        self.searchMethod(method);
        self.selectedSearchTerm = foodName;
      },
      /**
       * Sets a method of searching
       * @param method
       */
      searchMethod: function searchMethod(method) {
        let self = this;
        switch (method) {
          case 's':
            //shows results for autocomplete term, when its been called.
            self.activeDialogMethod = "searchResults";
            break;
          case 'a':
            self.activeDialogMethod = "autocomplete";
            //user wants to search with autocomplete.
            break;
          case 'b':
            self.activeDialogMethod = "barcode";
            //user wants to find food with barcode scanner.
            break;


          case 'mm':
            self.activeDialogMethod = "mymeals";
            //user wants to load from already saved list of foods.
            break;
        }
      },
      /**
       * Uses jQuery to add click event to input to open material datepicker
       * manually even though is hidden on the UI
       */
      openCalendar: function openCalendar() {
        $('#dateInput').click();
      },
      updateTargets: function updateTargets() {
        let self = this;
        self.isSettingsUpdating = true;
        SettingsApi.putNutritionSettings(self.settingsModel)
          .then(function (response) {
            self.nutritionTargets = JSON.parse(JSON.stringify(self.settingsModel));
            self.isSettingsUpdating = false;
            self.closeDialog('setTargetsDialog');
          })
      },
      /**
       * Gets data in context of date, no parameters required
       */
      getData: function getData() {
        let self = this;
        // self.isLoading = true;
        // self.totals.all.carbohydrate = 0;
        // self.totals.all.fat = 0;
        // self.totals.all.protein = 0;
        // self.totals.all.fibre = 0;

        self.barMode = "indeterminate";
        if (FoodApi.CancelRequests !== null) {
          FoodApi.CancelRequests();
        }
        FoodApi.withDate(moment(self.currentDate.actual).format('YYYY-MM-DD')).then(function (response) {
          self.totals = response.data.totals;
          self.foods = response.data.foods.meal_types;
          self.recipes = response.data.recipes;
          self.barMode = "determinate";
          self.isLoading = false;
          self.$forceUpdate();
          FoodApi.CancelRequests = null;
        }).catch(function () {
        });
      },
      /**
       * Adds a day
       */
      addDay: function addDay() {
        let self = this;
        self.currentDate.actual.add(1, 'day');
        self.$nextTick(function () {
          self.currentDate.ddmmyy = self.currentDate.actual.format('DD-MM-YYYY');
          self.currentDate.presentational = self.currentDate.actual.format('dddd Do MMMM, YYYY');
        })
      },
      /**
       * Takes away a day
       */
      subtractDay: function subtractDay() {
        let self = this;
        self.currentDate.actual.subtract(1, 'day');
        self.$nextTick(function () {
          self.currentDate.ddmmyy = self.currentDate.actual.format('DD-MM-YYYY');
          self.currentDate.presentational = self.currentDate.actual.format('dddd Do MMMM, YYYY');
        })
      },
      //Export food diary
      exportData() {
        let self = this;
        const fileName = 'nutrition' + `_${self.exportDate.fromDate}_${self.exportDate.toDate}.xlsx`;
        const requestPath = `tracking/nutrition/export?fromDate=${self.exportDate.fromDate}&toDate=${self.exportDate.toDate}`;
        const finalUrl = config.apiUrl + requestPath;
        const errorMessage = "Nothing to export";
        self.isExporting = true;
        axios.get(finalUrl, {
          responseType: 'blob',
          headers: {
            'Accept': 'application/vnd.ms-excel'
          }
        })
          .then(function (response) {
            if (response.status === 200) {
              const timestamp = self.isExporting = false;
              self.$toastr.success(self.$t('message.justAMomentText'));
              download(response.data, fileName);
              self.$refs['exportDataDialog'].close();
            }
            else if (response.status === 204) {
              self.$toastr.error(errorMessage);
              self.$toastr.error(self.$t('message.errorExportEmpty'));
              self.isExporting = false;
            }
            else {
              self.$toastr.error(errorMessage);
              self.isExporting = false;
            }
          })
          .catch(function () {
            self.$toastr.error(errorMessage);
            self.isExporting = false;
          })


      },

      /**
       * Checks if date is today
       * @param date
       * @returns {boolean}
       */
      isToday: function isToday(date) {
        return moment(date).isSame(moment(), 'day')
      },
      openDialog: function openDialog(ref, options) {
        let self = this;

        if (ref === 'exportDataDialog') {
          self.$refs[ref].open();
        }

        if (ref === 'addFoodDialog') {
          if ($(window).width() <= 768) {
            self.$router.push({
              name: 'FoodDiaryLanding',
              query: {
                date: self.currentDate.actual.format('YYYY-MM-DD'),
                mealTypeId: options.mealTypeId
              },
              params: {
                title: options.panelTitle,
                mealTypeId: options.mealTypeId,
              }
            })
          }
          else {
            self.activeMealType = options;
            self.$refs[ref].open();
          }
        }
        if (ref === 'editFoodDialog') {
          self.selectedFood = options;
          if ($(window).width() <= 768) {
            self.$router.push({
              name: 'FoodDiaryEdit',
              params: {
                title: options.panelTitle,
                mealTypeId: options.mealTypeId,
                foodObj: options
              }
            })
          }
          else {
            self.$refs[ref].open();
          }
        }
        else {
          self.$refs[ref].open();
        }
      },
      /**
       * Set search methods to null to reset it
       */
      onFoodDialogClose: function onFoodDiaryClose() {
        let self = this;
        let timeout = setTimeout(function () {
          self.activeDialogMethod = null;
          clearTimeout(timeout);
        }.bind(self), 300);
      },
      /**
       * Event for when the panel closes, empty the selected food.
       *
       **/
      onEditDialogClose: function onEditDialogClose() {
        let self = this;
        let timeout = setTimeout(function () {
          self.selectedFood = {};
          clearTimeout(timeout);
        }.bind(self), 300);
      },
      /**
       * Make panel scrollable with a bit of jQuery
       */
      onFoodDialogOpen: function onFoodDialogOpen() {
        let self = this;
        const $panelheight = $('.food-dialog-container').find('#md-dialog');
        const windowWidth = $(window).width();
        const $scrollHeight = $($panelheight.prevObject[0].children[0]).outerHeight() - 54;
        $('.scrollable-area').attr('style', "height:" + $scrollHeight + 'px;');
      },
      updateTotals: function updateTotals(substitutableNutrients) {
        let self = this;

        if (self.foods.all.length === 0 && self.recipes.all.length === 0) {
          self.totals.all.calories = 0;
          self.totals.all.carbohydrate = 0;
          self.totals.all.cholesterol = 0;
          self.totals.all.fat = 0;
          self.totals.all.fibre = 0;
          self.totals.all.monounsaturated_fat = 0;
          self.totals.all.polyunsaturated_fat = 0;
          self.totals.all.potassium = 0;
          self.totals.all.protein = 0;
          self.totals.all.saturated_fat = 0;
          self.totals.all.sodium = 0;
          self.totals.all.sugar = 0;
        }
        else
          self.$nextTick(function () {
            self.totals.all.calories -= substitutableNutrients.calories;
            self.totals.all.carbohydrate -= substitutableNutrients.carbohydrate;
            self.totals.all.cholesterol -= substitutableNutrients.cholesterol;
            self.totals.all.fat -= substitutableNutrients.fat;
            self.totals.all.fibre -= substitutableNutrients.fibre;
            self.totals.all.monounsaturated_fat -= substitutableNutrients.monounsaturated_fat;
            self.totals.all.polyunsaturated_fat -= substitutableNutrients.polyunsaturated_fat;
            self.totals.all.potassium -= substitutableNutrients.potassium;
            self.totals.all.protein -= substitutableNutrients.protein;
            self.totals.all.saturated_fat -= substitutableNutrients.saturated_fat;
            self.totals.all.sodium -= substitutableNutrients.sodium;
            self.totals.all.sugar -= substitutableNutrients.sugar;
            self.$forceUpdate();
          });


      },
      onNutritionUnitUpdate(payload) {
        this.setNutritionUnit(payload);
        this.closeDialog('editNutritionUnitDialog');
      },
      closeDialog: function closeDialog(ref) {
        let self = this;
        $('.scrollable-area').attr('style', '');
        self.$refs[ref].close();
        setTimeout(function () {
          self.activeDialogMethod = null;
          self.foodResultMode = "";
        }.bind(self), 300)
      },
      goTo: function goTo(name) {
        this.$router.push({
          name: name
        })
      },
     async setNutritionUnit(unit) {
        //Check if the user has actually changed their selection before re-rendering
        if (this.nutritionUnit !== unit) {
          this.nutritionUnit = unit;
          this.$forceUpdate();
          try {
            await SettingsApi.setFoodDiaryNutritionUnit({
              unit
            })
          } catch (e) {
            this.$toastr.error("Unable to save selection");
          }
        }
      },
      calculateCalorieValue(value, nutrient) {
        if (value < 0) {
          return 0;
        }
        switch (nutrient) {
          case('fat'):
              return value * 9;
          case ('carbohydrate'):
          case ('protein'):
              return value * 4;
        }
      },
      getNutrientDisplayValue(value, nutrient, hasMeasurement) {
        if (this.nutritionUnit === 'kcal') {
          if (hasMeasurement) {
            return this.calculateCalorieValue(value, nutrient).toFixed(1).toString() + 'kcal'
          } else {
            return this.calculateCalorieValue(value, nutrient).toFixed(1).toString();
          }
        }
        //Default to grams as returned by the api
        if (hasMeasurement) {
          return value.toFixed(1) + 'g'
        } else {
          if (value === 0) {
            return value
          } else {
            return value.toFixed(1);
          }
        }
      }
    }
  }
</script>
<style>

  .add-food-dialog {
    max-width: 740px;
  }

  .mu-slider.carbohydrate-slider .mu-slider-track,
  .mu-slider.fat-slider .mu-slider-track,
  .mu-slider.protein-slider .mu-slider-track {
    background: #9b9b9b !important;
  }

  .mu-slider.protein-slider .mu-slider-thumb {
    background: #ff5a5f;
    color: #ff5a5f
  }

  .mu-slider.protein-slider .mu-slider-fill {
    background: #ff5a5f;
    color: #ff5a5f;
  }

  .mu-slider.fat-slider .mu-slider-thumb {
    background: #ff895e;
    color: #ff895e;
  }

  .mu-slider.fat-slider .mu-slider-fill {
    background: #ff895e;
    color: #ff895e;
  }

  .mu-slider.carbohydrate-slider .mu-slider-thumb {
    background: #0179d5;
    color: #0179d5;
  }

  .mu-slider.carbohydrate-slider .mu-slider-fill {
    background: #0179d5;
    color: #0179d5;
  }

  .hiddenPicker {
    z-index: 99;
    position: absolute !important;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    opacity: 0;
    cursor: pointer !important;
  }

  .hiddenPicker input {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// FoodDiary.vue?1efac284